export default "__VITE_ASSET__CrsybrG1__"